import { Box, Container as MUIContainer, styled } from '@mui/material';
import { ImgHTMLAttributes } from 'react';

import { getAssetPath } from '@/constants/configs';

export const MainPageContainer = styled(Box)(({ theme }) => ({
  paddingTop: `calc(${theme.layout.headerHeight.lg}px + ${theme.spacing(8)})`,
  paddingBottom: theme.spacing(6),
}));

export const Container = styled(MUIContainer)(() => ({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
}));

export const Logo = styled((props: ImgHTMLAttributes<HTMLImageElement>) => (
  <img src={getAssetPath('/logo-with-text.svg')} {...props} />
))(() => ({
  width: 164,
}));
